import React from 'react'
import { ReactComponent as Logo } from '../../../assets/icons/dtp-mobile-logo.svg'

import './MobileHeader.scss'
import { useUI } from '../../../context/modalContext'

const MobileHeader = () => {
  const { navigateTo } = useUI()
  const handleExit = () => {
    navigateTo('/shiplocator')
  }

  return (
    <div id="mobile-header">
      <div className="logo-container">
        <Logo className="logo" />
        <div className="logo-text">Directions To Port</div>
      </div>
      <div className="exit-btn">
        <div className="btn" onClick={handleExit}>
          Exit
        </div>
      </div>
    </div>
  )
}

export default MobileHeader
